import { NavUser } from "../../components/ui/NavUser";
import { Link } from "react-router-dom";

export const SiteHeader = () => {
  return (
    <header className="sticky top-0 z-10 bg-white flex h-16 shrink-0 items-center gap-2 transition-[width,height] ease-linear shadow-[1px_1px_10px_-1px_rgba(215,215,215,1)]">
      <div className="flex items-center gap-2 p-3 justify-between min-w-full">
        <div className="flex items-center gap-2 px-4 ">
          <Link to="/">
            <img src="/assets/logo.png" alt="" />
          </Link>
        </div>
        <div className="max-w-fit">
          <NavUser />
        </div>
      </div>
    </header>
  );
};
